import { render, staticRenderFns } from "./SendDocumentTable.vue?vue&type=template&id=ad5f8f1e&scoped=true&lang=pug"
import script from "./SendDocumentTable.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTable.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTable.vue?vue&type=style&index=0&id=ad5f8f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5f8f1e",
  null
  
)

export default component.exports